import { IRegionSwitcherSettings } from '@r-client/republic/feature/main-header';
import {
  TEuropeJurisdictions,
  TRegionValidIds,
} from '@r-client/shared/feature/region';

type ISwitchingMode = 'cookie-only' | 'navigate';

interface IVariantsOpts {
  onChange: (id: TRegionValidIds) => void;
  onChangeForEuropeJurisdictions: (id: TEuropeJurisdictions) => void;
  mode: ISwitchingMode;
  republicEuropeBaseUrl: string;
}

export const regionalSwitcherVariants = ({
  onChange,
  onChangeForEuropeJurisdictions,
  mode,
  republicEuropeBaseUrl,
}: IVariantsOpts): IRegionSwitcherSettings['variants'] => [
  {
    name: 'Global',
    id: 'global',
    inlineName: 'global',
    titleName: 'Global',
    ...(mode === 'cookie-only'
      ? {
          onChange: () => onChange('global'),
        }
      : {
          onChange: () => onChange('global'),
          url: '/',
        }),
  },
  {
    name: 'United States',
    id: 'us',
    inlineName: 'US',
    titleName: 'US',
    onChange: onChange ? () => onChange('us') : undefined,
    needsConfirmation: true,
  },
  {
    name: 'Europe',
    id: 'europe',
    inlineName: 'europe',
    titleName: 'EU',
    needsConfirmation: true,
    onChange: onChangeForEuropeJurisdictions
      ? () => onChangeForEuropeJurisdictions('EU')
      : undefined,
    url: republicEuropeBaseUrl,
  },
  {
    name: 'United Kingdom',
    id: 'uk',
    inlineName: 'uk',
    titleName: 'UK',
    needsConfirmation: true,
    onChange: onChangeForEuropeJurisdictions
      ? () => onChangeForEuropeJurisdictions('GB')
      : undefined,
    url: republicEuropeBaseUrl,
  },
];
